/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaches_Page_Sample_ThreeInputs */

const en_coaches_page_sample_three = /** @type {(inputs: Coaches_Page_Sample_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anna Brooks`)
};

const pl_coaches_page_sample_three = /** @type {(inputs: Coaches_Page_Sample_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anna Kowal`)
};

/**
* | output |
* | --- |
* | "Anna Brooks" |
*
* @param {Coaches_Page_Sample_ThreeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_page_sample_three = /** @type {((inputs?: Coaches_Page_Sample_ThreeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Page_Sample_ThreeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_page_sample_three(inputs)
	return en_coaches_page_sample_three(inputs)
});